import { useState, useEffect } from "react";
import './allchapter.css'
import { Link } from "react-router-dom";
import Navbar from "./components/Navbar";



function BhagavadGitaChapter() {
  const [chapters, setChapters] = useState([]);

  useEffect(() => {
    fetch("https://bhagavad-gita3.p.rapidapi.com/v2/chapters/", {
      "method": "GET",
      "headers": {
        "x-rapidapi-host": "bhagavad-gita3.p.rapidapi.com",
        "x-rapidapi-key": '4034969b2cmshf9e4ab0b6a68552p1e99cajsn6474fa44b7c4'
      }
    })
    .then((res)=>{
      return res.json();
    })
    .then((res) => {
        // console.log(res)
        setChapters(res)
    })
    .catch(error => console.log(error));
  }, []);

  return (
    <>
    <Navbar/>
    <div name='chaptes' className="chap-container">
      <h2>Chapters</h2>
      <div className='chap-line'></div>
        {chapters?.map(chapter => (
            <Link to={'/chapter/'+ chapter.id} className="link">
            <div className="list-con" key={chapter.id}>
                <h3 className="title">{chapter.name}</h3>
                <h5 className="english-title">{chapter.name_meaning}</h5>
            </div>
            </Link>
        ))}
    </div>

    </>
    
  );
}

export default BhagavadGitaChapter;